import { type PropsWithChildren, createContext, useContext, useEffect, useState } from 'react'

import { CustomFieldsStore } from 'pages/settings/pages/customFields/store/customFieldsStore'

const CustomFieldsContext = createContext<CustomFieldsStore | null>(null)

export const useCustomFieldsContext = () => {
  const context = useContext(CustomFieldsContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with CustomFieldsProvider')

  return context
}

export const CustomFieldsProvider = ({ children }: PropsWithChildren) => {
  const [store] = useState(() => new CustomFieldsStore())

  useEffect(() => {
    store.init()

    return store.dispose
  }, [])

  return <CustomFieldsContext.Provider value={store}>{children}</CustomFieldsContext.Provider>
}
